var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.modal-bulk-replace-content-header",
              modifiers: { "modal-bulk-replace-content-header": true },
            },
          ],
          attrs: { block: "" },
        },
        [_vm._v("記事ヘッダ一群一括更新")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-bulk-replace-content-header",
            title: "記事ヘッダ一群一括更新",
            size: "lg",
            "no-close-on-backdrop": "",
            static: "",
          },
          on: { ok: _vm.bulkReplaceContentHeader },
        },
        [
          _c("p", [
            _vm._v("変換に使用するスプレッドシートのURLを入力してください。"),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n      シートの列名が以下になっている必要があります。"),
            _c("br"),
            _vm._v("\n      ・"),
            _c("strong", [_vm._v("Page ID")]),
            _vm._v("：記事のID (/page/ID.html の部分) "),
            _c("br"),
            _vm._v("\n      ・"),
            _c("strong", [_vm._v("Title")]),
            _vm._v("：変換後のタイトル（SNS や検索結果に表示される）"),
            _c("br"),
            _vm._v("\n      ・"),
            _c("strong", [_vm._v("H1")]),
            _vm._v("：変換後の記事タイトル（記事上で表示される）"),
            _c("br"),
            _vm._v("\n      ・"),
            _c("strong", [_vm._v("Description")]),
            _vm._v("：変換後のディスクリプション"),
            _c("br"),
            _vm._v("\n      (入力が空の場合は更新されません)\n    "),
          ]),
          _vm._v(" "),
          _c(
            "p",
            [
              _vm._v("\n      スプレッドシートURL：\n      "),
              _c("b-form-input", {
                model: {
                  value: _vm.spreadsheetUrl,
                  callback: function ($$v) {
                    _vm.spreadsheetUrl = $$v
                  },
                  expression: "spreadsheetUrl",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            [
              _vm._v("\n      シート名：\n      "),
              _c("b-form-input", {
                model: {
                  value: _vm.sheetTitle,
                  callback: function ($$v) {
                    _vm.sheetTitle = $$v
                  },
                  expression: "sheetTitle",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }